const yes = 'oui';
const no = 'non';

export class BooleanUtils {
  public static fromBooleanToString(value: boolean): string | null {
    if (value !== undefined && value !== null) {
      return value ? yes : no;
    }
    return null;
  }

  public static fromStringToBoolean(value: string): boolean {
    return value === yes;
  }
}
